export const SMS_MESSAGING = "sms-messaging"
export const SMS_MEDIA = "sms-media"



// WEBPACK FOOTER //
// ./src/state/sms/MessageTypes.ts